import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import * as MainConstants from "../../utils/MainConstants";
import Image from "material-ui-image";
import {Link} from "react-router-dom";

//import PWForVehicleOwner from "./PWForVehicleOwner";
//import PWForTowTruck from "./PWForTowTruck";
//import PWForCity from "./PWForCity";

const colortheme2 = createMuiTheme({
  palette: {
    primary: { main: "#f52d0a", contrastText: "#f52d0a" },
    secondary: { main: "#ffffff", contrastText: "#ffffff" }
  }
});

const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder)
  
});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
});

const handleClick = (e) => {
  e.preventDefault();
  console.log('The link was clicked.FAAAAAAAAAAAAARSHID');
}

class IntroductionPage extends Component {
  
  state = {
    age: '',
    name: 'hai',
  };
  
  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  
  render() {
    
    return (
      <div id="top1"  style={{   paddingRight:10 }}>
        <Grid container spacing={24}  >
          <Grid   item xs={12} sm={12}  md={4}  lg={4} xl={4} >
            <div  style = { { backgroundPosition:'center',    backgroundSize:'cover',  backgroundRepeat:'no-repeat',  marginLeft:30,  paddingTop:50, }}  >
              <Typography component="h4" variant="h5"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                {MainConstants.APPLICATION_NAME}&trade;
              </Typography>
              <Typography component="h1" variant="h4"   style = { { textAlign: 'left', alignSelf: 'left'  ,backgroundColor:'transparent' , color:'black'}} >For Vehicle Owner
              </Typography>
              <Typography component="h1" variant="h4"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'#e2580d'}} >
                ___________________
              </Typography>
              
              <Typography variant="h5"    style={{  color:'black'}}  align="left">
                Instead of discovering your car is gone, TowWatch gives you a real-time warning—so you can act before a tow happens.
                You can resolve the issue on the spot, move your vehicle, and avoid the time, cost, and frustration of recovering it from a tow lot.
                {/*Rather than having your car towed, TowWatch™ sends you a warning. While you’ll still be
                responsible for the applicable fee, you’ll avoid the time, cost, and
                frustration of recovering your vehicle from a tow lot.*/}
                {/*<Text>Instead of getting your car towed, we will warn you.
                You still pay the fee, but you will save all the time,
                  money and hassle from retrieving your car at the tow lot.</Text>*/}
              </Typography>
              
              {/*<ul>
                                                <li><Link to="/vehicle">Vehicle Owner more details</Link></li>
                                                </ul> */}
              <a href="/vehicle"  rel="noreferrer">
                <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                  Vehicle Owner more details &rArr;
                </Typography>
              </a>
            
            
            </div>
          </Grid>
          
          <Grid   item xs={12} sm={12}  md={4}  lg={4} xl={4} >
            
            
            <div  style = { { backgroundPosition:'center',    backgroundSize:'cover',  backgroundRepeat:'no-repeat',  marginLeft:30,  paddingTop:50, }}  >
              
              
              
              <Typography component="h4" variant="h5"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                {MainConstants.APPLICATION_NAME}&trade;
              </Typography>
              <Typography component="h1" variant="h4"   style = { { textAlign: 'left', alignSelf: 'left'  ,backgroundColor:'transparent' , color:'black'}} >For Tow Company
              </Typography>
              <Typography component="h1" variant="h4"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'#0a9110',  color:'#e2580d'}} >
                ___________________
              </Typography>
              
              <Typography component="h4" variant="h5"     style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                As a tow operator, {MainConstants.APPLICATION_NAME}&trade; gives you a faster way to handle violations—by notifying vehicle owners in real time and resolving the situation on-site.
                Collect applicable fees, have the vehicle moved, and move on to the next job—without the time, risk, or overhead of a full tow.
                {/*As a tow truck agent or driver, you can use the TowWatch™ app to notify vehicle owners and process
                towing fees on-site, allowing them to move their
                vehicle and eliminating the need to tow it to your garage.*/}
                {/*<Text>
                As a tow truck agent or driver, you can avoid towing vehicles to your garage by using the {MainConstants.APPLICATION_NAME}&trade; app to process the towing fees on the spot, and notifying the vehicle owner to move the vehicle.
                </Text>*/}
                </Typography>
              
              
              {/*<ul>
      <li><Link to="/towcompany">Tow Company more details</Link></li>
      </ul> */}
              <a href="/towcompany"  rel="noreferrer" >
                <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                  Tow Company more details &rArr;
                </Typography>
              </a>
            
            
            
            
            </div>
          </Grid>
          
          <Grid   item xs={12} sm={12}  md={4}  lg={4} xl={4} >
            
            
            <div  style = { { backgroundPosition:'center',    backgroundSize:'cover',  backgroundRepeat:'no-repeat',  marginLeft:30,  paddingTop:50, }}  >
              
              
              
              <Typography component="h4" variant="h5"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                {MainConstants.APPLICATION_NAME}&trade;
              </Typography>
              <Typography component="h1" variant="h4"   style = { { textAlign: 'left', alignSelf: 'left'  ,backgroundColor:'transparent' , color:'black'}} >For Municipality
              </Typography>
              <Typography component="h1" variant="h4"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'#540a91',  color:'#e2580d'}} >
                ___________________
              </Typography>
              
              
              <Typography component="h4" variant="h5"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                Reducing unnecessary towing is a simple, high-impact way for cities to improve traffic flow and air quality.
                With {MainConstants.APPLICATION_NAME}&trade;, municipalities can proactively prevent avoidable tows—cutting up to 800 metric tons of CO₂ emissions annually in a large city by minimizing unnecessary vehicle movement.
                {/*By reducing unnecessary towing, cities can ease traffic congestion and significantly improve air quality. On average, a large city can cut up to 800 metric tons of CO₂ emissions
                annually simply by minimizing vehicle towing operations.*/}
                {/*<Text>When a city removes unnecessary traffic, it reduces traffic congestion  and improves the air quality. On average, a big city can reduce 800 metric tons of Co2 emissions every year
                  by eliminating or reducing vehicle towing.</Text>*/}
              </Typography>
              
              {/*}
      <ul>
      <li><Link to="/citydetails">City more details &rArr;</Link></li>
      
      </ul> */}
              <a href="/citydetails"  rel="noreferrer">
                <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                  Municipality more details &rArr;
                </Typography>
              </a>
            
            
            
            </div>
          </Grid>
          {/*}
          <Grid   item xs={12} sm={12}  md={3}  lg={3} xl={3} >
            <div  style = { { backgroundPosition:'center',   backgroundSize:'cover',  backgroundRepeat:'no-repeat',  marginLeft:30,  paddingTop:50, }}  >
              <Typography component="h4" variant="h5"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                {MainConstants.APPLICATION_NAME}&trade;
              </Typography>
              <Typography component="h1" variant="h4"   style = { { textAlign: 'left', alignSelf: 'left'  ,backgroundColor:'transparent' , color:'black'}} >For Municipality
              </Typography>
              <Typography component="h1" variant="h4"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'#540a91',  color:'#e2580d'}} >
                ___________________
              </Typography>
              <Typography component="h4" variant="h5"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                When a city removes unnecessary traffic, it reduces traffic congestion  and improves the air quality. On average, a big city can reduce 800 metric tons of Co2 emissions every year
                by eliminating or reducing vehicle towing.
              </Typography>
              <a href="/citydetails"  rel="noreferrer">
                <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                  Municipality more details &rArr;
                </Typography>
              </a>
            </div>
          </Grid>
          */}
        </Grid>
      </div>
    
    
    
    
    );
  }
}

IntroductionPage.propTypes = {
  classes: PropTypes.object.isRequired,
};
//export default BiomassView;
export default withStyles(styles)(IntroductionPage);
